import { render, staticRenderFns } from "./ImagePanel.vue?vue&type=template&id=63473abc&scoped=true&"
import script from "./ImagePanel.vue?vue&type=script&lang=js&"
export * from "./ImagePanel.vue?vue&type=script&lang=js&"
import style0 from "./ImagePanel.vue?vue&type=style&index=0&id=63473abc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63473abc",
  null
  
)

export default component.exports